import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AdvogadoRegistroComponent} from '../../shared/advogado-registro/advogado-registro.component';
import {TelefoneComponent} from '../../shared/telefone/telefone.component';
import {CampoObrigatorio} from '../../validators/campo-obrigatorio';
import {MSG_OBG_MOTIVO_REQUERIMENTO} from '../../../../../tools/Mensagens';
import {AplicarRegraCampos} from '../../validators/aplicar-regra-campos';
import {MotivoRequerimentoEnum, obterDescricaoEnum} from '../propria-parte-requerimento-geral/motivo-requerimento.enum';
import {CpeResponseDTO} from "../../../../../componentes/cpe-operador/dto/CpeResponseDTO";

@Component({
  selector: 'app-pelo-advogado-requerimento-geral',
  templateUrl: './pelo-advogado-requerimento-geral.component.html',
  styleUrls: ['./pelo-advogado-requerimento-geral.component.css']
})
export class PeloAdvogadoRequerimentoGeralComponent implements OnInit, OnDestroy {

  @Input() formulario: FormGroup;
  @Input() somenteLeitura: boolean = false;
  @Input() dados: CpeResponseDTO;
  @ViewChild(AdvogadoRegistroComponent, {static: false}) advogadoRegistroComponent: AdvogadoRegistroComponent;
  @ViewChild(TelefoneComponent, {static: false}) telefoneComponent: TelefoneComponent;
  protected readonly obterDescricaoEnum = obterDescricaoEnum;
  idPeticaoMaxLength = 9;


  constructor() {
  }

  ngOnInit() {
    if(!this.somenteLeitura){
      const valorInicialMotivoRequerimento = this.dados && this.dados.motivoRequerimento ? this.dados.motivoRequerimento : '';
      const valorInicialIdPeticao = this.dados && this.dados.idPeticao ? this.dados.idPeticao : '';

      this.getFormulario().setControl('motivoRequerimento', new FormControl(valorInicialMotivoRequerimento, Validators.required));
      this.getFormulario().setControl('idPeticao', new FormControl(valorInicialIdPeticao, Validators.maxLength(this.idPeticaoMaxLength)));
    }
  }

  ngOnDestroy() {
    if(!this.somenteLeitura) {
      this.getFormularioGeral().removeControl('advogadoInformacaoRequerente');
    }
  }

  validarFormulario() {
    this.validarRegistroAdvogado();
    this.validarTelefone();

    const campos = [{
      control: 'motivoRequerimento',
      mensagem: MSG_OBG_MOTIVO_REQUERIMENTO,
      regra: this.validarMotivoRequerimento.bind(this)
    }];

    AplicarRegraCampos.aplicar(campos, this.getFormulario());
  }

  protected getFormulario() {
    let formAdvogadoInformacaoRequerente = this.formulario.get('requerimentoGeral').get('advogadoInformacaoRequerente') as FormGroup;
    if (!formAdvogadoInformacaoRequerente) {
      formAdvogadoInformacaoRequerente = new FormGroup({});
      this.getFormularioGeral().setControl('advogadoInformacaoRequerente', formAdvogadoInformacaoRequerente);
    }
    return formAdvogadoInformacaoRequerente;
  }

  protected obterListaMotivoRequerimentoFiltradoPorNumero(): number[] {
    return Object.values(MotivoRequerimentoEnum).filter(value => typeof value === 'number') as number[];
  }

  private validarMotivoRequerimento(value: any): boolean {
    return CampoObrigatorio.aplicar(value);
  }

  private validarRegistroAdvogado(): void {
    if (this.advogadoRegistroComponent) {
      this.advogadoRegistroComponent.validarFormulario();
    }
  }

  private validarTelefone() {
    if (this.telefoneComponent) {
      this.telefoneComponent.validarFormulario();
    }
  }

  private getFormularioGeral() {
    return this.formulario.get('requerimentoGeral') as FormGroup;
  }

  protected readonly Number = Number;
}
